module.exports = __webpack_public_path__ + "img/warehousing.e480edfb.jpg";